import Format from '../utility/Format';
import LaneClosureRequest from './LaneClosureRequest';

export default class AuditLogRestriction {
    constructor(data) {
        data.forEach(item => {
            this.constructFields(item);
        });
    }

    constructFields(data) {
    	if (data.changesDetails == null) {
    		return;
    	}
        let dataJson = JSON.parse(data.changesDetails)["Restrictions"];

        this.restrictions = {};

        dataJson.forEach(item => {
            if (!this.restrictions[item.RestrictionTypeId]) {
                this.restrictions[item.RestrictionTypeId] = {
                    text: `${Format.searchById(item.DirectionId, LaneClosureRequest.getDirectionIdOptions).name} ${Format.searchById(item.RestrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).name}`,
                    img: Format.searchById(item.RestrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions).img,
                    items: []
                };
            }
            this.restrictions[item.RestrictionTypeId].items.push(item);
        });
    }

    getContent() {
        return Object.values(this);
    }
}